import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { App } from 'redpoints-front-common/appLoader';
import { withLogin } from 'redpoints-front-common/authentication';

import {
  APPLICATION_NAME,
  APPLICATION_SUITE,
  APPLICATION_TOKEN,
  DEFAULT_PAGE_PATH_ON_TENANT_CHANGE,
  ENVIRONMENT,
  PAGE_PATHS_TO_REDIRECT_ON_TENANT_CHANGE,
  ROUTES,
  SCHEME,
  VERSION,
} from './config/constants';
import menuConfig from './config/menuConfig';
import routes from './routes';
import configureStore from './store';

import './styles/reset.css';
import './styles/styles.less';

const { store } = configureStore();

const appConfig = Object.freeze({
  APPLICATION_NAME,
  APPLICATION_SUITE,
  APPLICATION_TOKEN,
  DEFAULT_PAGE_PATH_ON_TENANT_CHANGE,
  ENVIRONMENT,
  PAGE_PATHS_TO_REDIRECT_ON_TENANT_CHANGE,
  ROUTES,
  SCHEME,
  VERSION,
  hasClarity: true,
});

const AppWithLogin = withLogin({
  App: props => (
    <Provider store={store}>
      <App
        {...props}
        appConfig={appConfig}
        menuConfig={menuConfig}
        routes={routes}
      />
    </Provider>
  ),
  appData: {
    applicationToken: APPLICATION_TOKEN,
    suite: APPLICATION_SUITE,
    environment: ENVIRONMENT,
    scheme: SCHEME,
  },
});

ReactDOM.render(<AppWithLogin />, document.getElementById('root'));
